import { IClinic, IFlags, IService } from '@/modules/Auth/auth-types'

type logoType = {
  show?: boolean
  b2c?: string
  mobile?: string
  login?: string
  menu?: string
}

type IServices = {
  servicoAssistenteSocial?: IService
  servicoDentista?: IService
  servicoEnfermagem?: IService
  servicoFisioterapeuta?: IService
  servicoFonoaudiologo?: IService
  servicoMedico?: IService
  servicoNutricao?: IService
  servicoPsicologia?: IService
  servicoPsicologiaViva?: IService
}

export class Clinic {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private _id: number,
    private _uniqueCode: string,
    private _name: string,
    private _flag: IFlags,
    private _logos: logoType,
    private _firstConsultText: string,
    private _firstConsultAuxiliaryText: string,
    private _minimumHoursToCancel: number,
    private _linkRedirectAfterAttendance: string,
    public services: IServices,
    public urlTerms: string,
  ) {}

  get flag(): IFlags {
    return this._flag
  }

  get name(): string {
    return this._name
  }

  get logos(): logoType {
    if (this.flag.MostrarLogoPropria) {
      return {
        show: true,
        ...this._logos,
      }
    } else
      return {
        show: false,
        ...this._logos,
      }
  }

  get id(): number {
    return this._id
  }

  get uniqueCode(): string {
    return this._uniqueCode
  }

  get minimumHoursToCancel(): number {
    return this._minimumHoursToCancel
  }

  get defaultSearchOrder(): string {
    if (this._flag.OrdenacaoPorNomeProfissional) {
      return 'NAME'
    } else {
      return 'DATE'
    }
  }

  get canPrivateAttendance(): boolean {
    return this._flag.PermiteConsultaParticular
  }

  get canChat(): boolean {
    return this._flag.HabilitarChat
  }

  firstConsult(): { enabled: boolean; text: string; auxiliaryText: string } {
    return {
      enabled: this.flag.VerificaPrimeiroAtendimento,
      text: this._firstConsultText,
      auxiliaryText: this._firstConsultAuxiliaryText,
    }
  }

  get hasMultipleHealthInsuranceCards(): boolean {
    return this._flag.HabilitarMultiplosCartoesConvenio
  }

  get hasZendeskConfig(): boolean {
    return this._flag.CuidadoEspeciaisZendesk
  }

  get linkRedirectAfterAttendance(): string {
    return this._linkRedirectAfterAttendance
  }
}

export const buildClinicFromInterface = (
  clinic: IClinic,
  flags: IFlags,
): Clinic => {
  return new Clinic(
    clinic.idClinica,
    clinic.codigoUnico,
    clinic.nomeAmigavel,
    flags,
    {
      b2c: clinic.urlsLogotipo.URL_LOGO_B2C,
      mobile: clinic.urlsLogotipo.URL_LOGO_MOBILE,
      login: clinic.urlsLogotipo.URL_LOGO_TELA_LOGIN,
      menu: clinic.urlsLogotipo.URL_LOGO_TOPO_MENU,
    },
    clinic.textoPrimeiroAtendimento,
    clinic.textoPrimeiroAtendimentoComplemento,
    clinic.minimoHorasCancelamento,
    clinic.linkRedirecionamentoAposChamada,
    {
      servicoAssistenteSocial: clinic.servicoAssistenteSocial,
      servicoDentista: clinic.servicoDentista,
      servicoEnfermagem: clinic.servicoEnfermagem,
      servicoFisioterapeuta: clinic.servicoFisioterapeuta,
      servicoFonoaudiologo: clinic.servicoFonoaudiologo,
      servicoMedico: clinic.servicoMedico,
      servicoNutricao: clinic.servicoNutricao,
      servicoPsicologia: clinic.servicoPsicologia,
      servicoPsicologiaViva: clinic.servicoPsicologiaViva,
    },
    clinic.urlTermoPaciente,
  )
}
